import React from 'react';
import { useRealtime } from '../../contexts/RealtimeContext';
import StudentInfo from './StudentInfo';

const StudentInfoPage = () => {
  const { userProfile } = useRealtime();
  const coachingId = userProfile?.coachingId || '';
  return (
    <div className="max-w-7xl mx-auto p-4 sm:p-6">
      <StudentInfo coachingId={coachingId} />
    </div>
  );
};

export default StudentInfoPage;
